"use client";

import { motion } from "motion/react";
import { useState, useEffect } from "react";
import Arbeiten from "./components/Arbeiten/Arbeiten";
import Landing from "./components/Landing/Landing";
import Leistungen from "./components/Leistungen/Leistungen";
import Leistungen2 from "./components/Leistungen2/Leistungen2";
import Kontakt from "./components/Kontakt/Kontakt";
import Footer from "./components/Footer/Footer";


export default function Home() {
  const [isAtBottom, setIsAtBottom] = useState(false);
  
  useEffect(() => {
    const BOTTOM_THRESHOLD = 100;
    
    const handleScroll = () => {
      const { scrollHeight } = document.documentElement;
      const scrollTop = window.scrollY;
      const { innerHeight } = window;
      
      setIsAtBottom(scrollHeight - scrollTop - innerHeight < BOTTOM_THRESHOLD);
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const handleScrollClick = () => {
    if (isAtBottom) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    
    const SECTION_IDS = ['arbeiten', 'leistungen', 'leistungen2', 'kontakt'] as const;
    const SCROLL_OFFSET = 100;
    const scrollTop = window.scrollY;
    
    for (const sectionId of SECTION_IDS) {
      const el = document.getElementById(sectionId);
      if (!el) continue;
      
      const elementTop = el.getBoundingClientRect().top + scrollTop;
      if (elementTop > scrollTop + SCROLL_OFFSET) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    
    document.getElementById(SECTION_IDS[0])?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  
  return (
    <>
      <Landing />
      <Arbeiten />
      <Leistungen />
      <Leistungen2 />
      <Kontakt />
      <Footer />
      
      {/* Dynamic Scroll Button */}
      <motion.button
        aria-label={isAtBottom ? "Nach oben scrollen" : "Weiter scrollen"}
        onClick={handleScrollClick}
        whileHover={{ scale: 1.06, y: isAtBottom ? 6 : -6 }}
        whileTap={{ scale: 0.98 }}
        animate={{ 
          y: isAtBottom ? [0, 12, 0] : [0, -12, 0], 
          rotate: isAtBottom ? [0, 6, 0] : [0, -6, 0] 
        }}
        transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
        className="fixed z-[var(--z-top)] inline-flex items-center justify-center gap-2 rounded-full border-[3px] xs:border-[var(--border-xl)] border-[var(--dark-blue)] bg-[var(--yellow)] w-12 h-12 xs:w-[var(--scroll-button-size)] xs:h-[var(--scroll-button-size)] p-1 xs:p-2 text-sm font-[Poppins] font-bold text-[var(--dark-blue)] shadow-[3px_3px_0_var(--dark-blue)] xs:shadow-[var(--shadow-lg)] pointer-events-auto"
        style={{ bottom: 'var(--scroll-button-bottom)', right: 'var(--scroll-button-right)' }}
      >
        <motion.svg 
          width="42" 
          height="42" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg" 
          className="block w-6 h-6 xs:w-[42px] xs:h-[42px]"
          animate={{ rotate: isAtBottom ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <path d="M12 4v12" stroke="#1d2b4f" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.5 11.5L12 17l5.5-5.5" fill="none" stroke="#1d2b4f" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </motion.svg>
      </motion.button>
    </>
  );
}
